module.exports = __webpack_public_path__ + "static/media/quiikmeet-06.3e4da8ae.png";